/** Egyszerű, ígéret-alapú modális ablak (natív <dialog>). */
export interface ModalAction<T> {
  label: string;
  value: T;
  variant?: 'primary' | 'danger' | 'ghost';
}

export function showModal<T>(opts: {
  title: string;
  body: string;
  actions: ModalAction<T>[];
}): Promise<T | null> {
  return new Promise((resolve) => {
    const dialog = document.createElement('dialog');
    dialog.className = 'modal';
    dialog.innerHTML = `
      <h2 class="modal__title"></h2>
      <p class="modal__body"></p>
      <div class="modal__actions"></div>
    `;
    dialog.querySelector('.modal__title')!.textContent = opts.title;
    dialog.querySelector('.modal__body')!.textContent = opts.body;

    const actions = dialog.querySelector('.modal__actions')!;
    for (const action of opts.actions) {
      const btn = document.createElement('button');
      btn.className = `btn btn--${action.variant ?? 'ghost'}`;
      btn.textContent = action.label;
      btn.addEventListener('click', () => {
        dialog.close();
        resolve(action.value);
      });
      actions.appendChild(btn);
    }

    dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
      dialog.close();
      resolve(null);
    });
    dialog.addEventListener('close', () => dialog.remove());

    document.body.appendChild(dialog);
    dialog.showModal();
  });
}

/** Egysoros szövegbekérő (új fájl neve, átnevezés). */
export function promptText(opts: {
  title: string;
  label: string;
  value: string;
  confirmLabel?: string;
}): Promise<string | null> {
  return new Promise((resolve) => {
    const dialog = document.createElement('dialog');
    dialog.className = 'modal';
    dialog.innerHTML = `
      <h2 class="modal__title"></h2>
      <label class="modal__label"><span></span><input class="modal__input" type="text" /></label>
      <div class="modal__actions">
        <button class="btn btn--ghost" data-cancel>Mégse</button>
        <button class="btn btn--primary" data-ok></button>
      </div>
    `;
    dialog.querySelector('.modal__title')!.textContent = opts.title;
    dialog.querySelector('.modal__label span')!.textContent = opts.label;
    const input = dialog.querySelector<HTMLInputElement>('.modal__input')!;
    input.value = opts.value;

    const ok = dialog.querySelector<HTMLButtonElement>('[data-ok]')!;
    ok.textContent = opts.confirmLabel ?? 'Rendben';

    const finish = (value: string | null) => {
      dialog.close();
      resolve(value);
    };
    ok.addEventListener('click', () => finish(input.value.trim() || null));
    dialog.querySelector('[data-cancel]')!.addEventListener('click', () => finish(null));
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') finish(input.value.trim() || null);
    });
    dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
      finish(null);
    });
    dialog.addEventListener('close', () => dialog.remove());

    document.body.appendChild(dialog);
    dialog.showModal();
    input.select();
  });
}
